import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3a909882&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3a909882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a909882",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotelCard: require('/workspace/components/HotelCard.vue').default,ShimmerEffectMultiple: require('/workspace/components/ShimmerEffectMultiple.vue').default,ActivityBlog: require('/workspace/components/ActivityBlog/ActivityBlog.vue').default})
